// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Loader_Loader__iJzyF","center":"Loader_center__Hfnoz"};